import { cn } from '@/lib/utils';
import { ChatMarkdown } from './chat-markdown';

type MessageRole = 'user' | 'assistant';

interface ChatMessageProps {
  role: MessageRole;
  content: string;
  maxWidth?: string;
  className?: string;
}

export function ChatMessage({
  role,
  content,
  maxWidth = 'max-w-[85%]',
  className,
}: ChatMessageProps) {
  const isUser = role === 'user';

  return (
    <div
      className={cn(
        'flex',
        isUser ? 'justify-end' : 'justify-start',
        className,
      )}
    >
      <div
        className={cn(
          maxWidth,
          'p-2.5 rounded-lg',
          isUser
            ? 'bg-stone-700 text-stone-50'
            : 'bg-stone-100 text-stone-800 border border-stone-300',
        )}
      >
        {isUser ? (
          <p className="text-sm whitespace-pre-wrap break-words">{content}</p>
        ) : (
          <ChatMarkdown>{content}</ChatMarkdown>
        )}
      </div>
    </div>
  );
}
